import { create } from 'apisauce';
import cache from '../utility/cache';
import authStorage from '../auth/storage';
import settings from '../utility/settings';

const apiClient = create({
	baseURL: settings.apiUrl,
	timeout: 20000,
});

apiClient.addAsyncRequestTransform(async (request) => {
	const authToken = await authStorage.getToken();
	if (!authToken) return;
	request.headers['x-auth-token'] = authToken;
});

const get = apiClient.get;
apiClient.get = async (url, params, axiosConfig, saveCache = true) => {
	if (saveCache) {
		const cachedData = await cache.get(url);
		if (cachedData) return { ok: true, data: cachedData };
	}

	const response = await get(url, params, axiosConfig);

	if (response.ok && saveCache) {
		cache.store(url, response.data);
	}

	return response;
};
export default apiClient;
